/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverrideAnalysisResultRequest
 */
export interface OverrideAnalysisResultRequest {
    /**
     * The new criteria result to override with
     */
    criteria_result: OverrideAnalysisResultRequestCriteriaResultEnum;
    /**
     * The reason for overriding the analysis result
     */
    override_reason: OverrideAnalysisResultRequestOverrideReasonEnum;
    /**
     * Additional comment explaining the override
     */
    comment: string;
}


/**
 * @export
 */
export const OverrideAnalysisResultRequestCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A',
} as const;
export type OverrideAnalysisResultRequestCriteriaResultEnum = typeof OverrideAnalysisResultRequestCriteriaResultEnum[keyof typeof OverrideAnalysisResultRequestCriteriaResultEnum];

/**
 * @export
 */
export const OverrideAnalysisResultRequestOverrideReasonEnum = {
    IncompleteOrMissingPatientData: 'Incomplete or missing patient data',
    NewInformationReceived: 'New information received',
    AiReasoningIssues: 'AI reasoning issues',
    AiExtractionOrReadingError: 'AI extraction or reading error',
    ClinicalJudgmentDiffers: 'Clinical judgment differs',
} as const;
export type OverrideAnalysisResultRequestOverrideReasonEnum = typeof OverrideAnalysisResultRequestOverrideReasonEnum[keyof typeof OverrideAnalysisResultRequestOverrideReasonEnum];


/**
 * Check if a given object implements the OverrideAnalysisResultRequest interface.
 */
export function instanceOfOverrideAnalysisResultRequest(value: object): value is OverrideAnalysisResultRequest {
    if (!('criteria_result' in value) || value['criteria_result'] === undefined) return false;
    if (!('override_reason' in value) || value['override_reason'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function OverrideAnalysisResultRequestFromJSON(json: any): OverrideAnalysisResultRequest {
    return OverrideAnalysisResultRequestFromJSONTyped(json, false);
}

export function OverrideAnalysisResultRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResultRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'criteria_result': json['criteria_result'],
        'override_reason': json['override_reason'],
        'comment': json['comment'],
    };
}

export function OverrideAnalysisResultRequestToJSON(json: any): OverrideAnalysisResultRequest {
    return OverrideAnalysisResultRequestToJSONTyped(json, false);
}

export function OverrideAnalysisResultRequestToJSONTyped(value?: OverrideAnalysisResultRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criteria_result': value['criteria_result'],
        'override_reason': value['override_reason'],
        'comment': value['comment'],
    };
}

